export default __webpack_public_path__ + "static/media/bubble.7ddafa58.png";